import Topbar from "../layout/Topbar";
import React from "react";
import SettingsSidebar from "./SettingsSidebar";
import ReportingSettings from "./ReportingSettings";
import CompanySettings from "./CompanySettings";
import ProfileSettings from "./ProfileSettings";
import {alertActions} from "../../store/actions/alertActions";
import {connect} from "react-redux";
import {authActions} from "../../store/actions/authAction";
import {Box, CssBaseline} from "@mui/material";
import {settingsPageStyles, SettingsPageHeader} from "./SettingsDesign";
import {styled} from "@mui/system";

export const SettingsRoot = styled(Box)(({theme}) => ({
    display: "flex",
    backgroundColor: theme.palette.background.darkBlue,
    color: theme.palette.text.primary,
    maxWidth: "100%"
}));

export const SettingsContentBox = styled(Box)(({theme}) => ({
    height: "var(--app-height)",
    width: "100%",
    overflow: "auto",
    borderLeft: "1px solid " + theme.palette.background.tableBorder,
    paddingTop: 66,
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down(600)]: {
        paddingTop: 66,
    }
}));

function General(props) {
    const {role} = props?.state?.auth?.userSettings;
    return (
        <SettingsRoot>
            <CssBaseline/>
            <Topbar/>
            <SettingsSidebar {...props}/>
            <SettingsContentBox sx={settingsPageStyles}>
                <Box display="flex" flexWrap="wrap" flexDirection="column" justifyContent="center">
                    <Box sx={{width: '100%', maxWidth: 900, mx: 'auto', px: {xs: 0, sm: '30px'}, pt: 3}}>
                        <SettingsPageHeader title="General Settings"/>
                    </Box>
                    <Box sx={{mb: {xs: 3, sm: 0}}}>
                        <ProfileSettings {...props}/>
                    </Box>
                    <Box sx={{mb: {xs: 3, sm: 0}}}>
                        <ReportingSettings {...props}/>
                    </Box>
                    {(role === "owner" || role === "manager") &&
                        <Box>
                            <CompanySettings {...props}/>
                        </Box>
                    }
                </Box>
            </SettingsContentBox>
        </SettingsRoot>
    );
}

const mapStateToProps = (state) => {
    return {
        state: {
            alert: state.alert,
            auth: state.auth
        }
    };
};

const mapDispatchToProps = {
    errorMsg: alertActions.error,
    successMsg: alertActions.success,
    clear: alertActions.clear,
    updateUserSettings: authActions.updateUserSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(General);